import {Controller} from "@hotwired/stimulus"
import dispatchSelectLoaded from "../utils/dispatch_select_loaded.js";

/**
 * DependentSelectController allows to update a select element based on other
 * select elements.
 *
 * `update` checks all `filter`s, pulls their values with query names. Then it
 * iterates over all dependent selects and for each of them queries the URL for
 * that select, adding filter as query params. It expects back a JSON list with
 * objects with id & name. It builds `option`s for the select, copying
 * the empty option.
 *
 * If a filter is also a dependent select, changing its value will not update
 * itself.
 *
 * The controller does not do any initial setup of dependent selects.
 *
 * %div{data: { controller: 'dependent-select' }}
 *  %select{name: 'entity_id',
 *          data: { action: 'change->dependent-select#update',
 *                  dependent_select_target: 'filter',
 *                  dependent_select_query_name_value: 'entity_id'}}
 *    %option{value: 23} Entity A
 *    %option{value: 69} Entity B
 *    %option{value: 88} Entity C
 *
 *  %select{name: 'device_id',
 *          data: { dependent_select_target: 'select',
 *                  dependent_select_url_value: '/entities.json'}}
 *    %option{value: ''} ---
 *    %option{value: 1} Device A
 *    %option{value: 2} Device B
 *
 * Expected response (JSON):
 *    [{id: 1, name: 'Device A'}, {id: 2, name: 'Device B'}]
 */
export default class extends Controller {
  static targets = ['select', 'filter']

  update(e) {
    let filter = {}
    this.filterTargets.forEach(f => {
      filter[f.dataset.dependentSelectQueryNameValue] = f.value
    })

    this.selectTargets.forEach(s => {
      if (e.currentTarget === s) return

      const url = URL.parse(s.dataset.dependentSelectUrlValue);

      const params = new URLSearchParams(url.search);
      Object.keys(filter).forEach(key => {
        params.set(key, filter[key]);
      });
      url.search = params.toString();

      fetch(url.toString())
        .then(response => response.json())
        .then(list => {
          list.unshift({id: '', name: s.querySelector('option[value=""]').text})
          s.innerHTML = list.map(item => {
            return `<option value="${item.id}">${item.name}</option>`
          }).join('')

          /** If we use SelectSearchController,
           * we must send it select:loaded event to create an instance.
           */
          dispatchSelectLoaded(s);
        });
    })
  }
}